import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface UserState {
  id: number | null;
}

const initialState: UserState = {
  id: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserId: (state, action: PayloadAction<number>) => {
      state.id = action.payload;
    },
  },
});

export const { setUserId } = userSlice.actions;

export const selectUserId = (state: RootState) => state.user.id;
export const selectIsDev = (state: RootState) =>
  state.user.id === 1 || state.user.id === 2;

export default userSlice.reducer;
